<template>
  <div class="col-sm-6 col-lg-3 pd-5">
    <div class="card min-height card-hover-rise mb-0" :style="{ backgroundColor: statisticsItem[itemKey].background_color }">
      <div class="d-flex justify-content-between">
        <div class="text-left card-head">
          <h5 class="px-1 pt-1 font-bold">{{ statisticsItem[itemKey].name }}</h5>
        </div>
        <div class="justify-content-end px-1 py-1 text-right">
          <select v-if="statisticsItem[itemKey].is_filterable"
                @change="$emit('onDateChange', statisticsItem[itemKey])"
                v-model="statisticsItem[itemKey].date_range" class="form-control width-100"
                style="padding: 0; border:none; text-align: center"
                :style="{ backgroundColor: statisticsItem[itemKey].background_color }">
            <option value="" disabled selected>Select Range</option>
            <option v-for="(range, j) in timeRange" :key="j" :value="range.value">{{ range.name }}</option>
          </select>
          <div v-else class="d-flex justify-content-end" :style="{ backgroundColor: statisticsItem[itemKey].background_color }">
            <span @click="navigate(statisticsItem[itemKey].url)" class="cursor-pointer">See All</span>
          </div>
        </div>
      </div>
        
      <hr style="margin:0">
      <div v-if="statisticsItem[itemKey].url" @click="reDirect(statisticsItem[itemKey].url_type, statisticsItem[itemKey].url)"
           class="cursor-pointer card-body d-flex justify-content-between align-items-center p-1">
        <div class="truncate">
          <h4 class="mb-25 font-bold text-left">
            {{ commaFormat(statisticsItem[itemKey].value) }} </h4>
        </div>
        <span class="b-avatar badge-light-primary rounded-circle">
          <span class="b-avatar-custom">
            <img id="img" :src="`/app-assets/images/icons/dashboard/${itemKey}.png`" alt="">
          </span>
        </span>
      </div>
      <div v-else class="card-body d-flex justify-content-between align-items-center p-1">
        <div class="truncate">
          <h4 class="mb-25 font-bold text-left">
            {{ commaFormat(statisticsItem[itemKey].value) }} </h4>
        </div>
        <span class="b-avatar badge-light-primary rounded-circle">
          <span class="b-avatar-custom">
            <img id="img" :src="`/app-assets/images/icons/dashboard/${itemKey}.png`" alt="">
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import figureFormatter from "@/services/utils/figureFormatter";
import {useRoute, useRouter} from "vue-router";
import handleRedirectToPage from "@/services/modules/redirectToPage";
import useDate from "@/services/utils/day";

const router = useRouter();
const route = useRoute();

const {commaFormat} = figureFormatter()
const {goToPage} = handleRedirectToPage()

const {firstDateOfMonth, lastDateOfMonth} = useDate()

defineProps({
  statisticsItem: Object,
  page: Object,
  timeRange: Array,
  itemKey: String
})

const reDirect = (urlType='', url='') => {
  switch (urlType) {
    case 'internal':
      navigate(url);
      break;
    case 'external':
      goToPage(url);
      break;
  }
}

const navigate = (url) => {
  router.push({name: url, params: route.params, query: {start: firstDateOfMonth, end: lastDateOfMonth}});
}
</script>

<style scoped>
.min-height {
  min-height: 150px;
}
#img {
  width: 50px;
}
.card-hover-rise {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card-hover-rise:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
.font-bold {
  font-weight: bold;
}
.card-head {
  h2 {
    font-weight: bold;
  }
}
</style>
